"use client";

import { c as _c } from "react/compiler-runtime";
import { Button } from "@opensea/next-ui-kit";
import { Media, Tooltip } from "@opensea/ui-kit";
import { FilterList, KeyboardDoubleArrowLeft } from "@opensea/ui-kit/icons";
import { useContextSelector } from "use-context-selector";
import { FilterLayoutContext } from "./FilterLayoutProvider";
export function FilterSidePanelToggle(t0) {
  const $ = _c(17);
  const {
    onClick
  } = t0;
  const [isFilterSidePanelOpen, setIsFilterSidePanelOpen, setIsFilterSheetOpen] = useContextSelector(FilterLayoutContext, _temp);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      variant: "secondary",
      size: "sm"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const buttonProps = t1;
  let t2;
  if ($[1] !== onClick || $[2] !== setIsFilterSheetOpen) {
    t2 = <Media lessThan="xl"><Button icon={FilterList} onClick={() => {
        if (onClick) {
          onClick();
          return;
        }
        setIsFilterSheetOpen(_temp2);
      }} {...buttonProps} /></Media>;
    $[1] = onClick;
    $[2] = setIsFilterSheetOpen;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const t3 = isFilterSidePanelOpen ? "Collapse filters" : "Filters";
  const t4 = isFilterSidePanelOpen ? KeyboardDoubleArrowLeft : FilterList;
  let t5;
  if ($[4] !== isFilterSidePanelOpen || $[5] !== onClick || $[6] !== setIsFilterSidePanelOpen) {
    t5 = () => {
      if (onClick) {
        onClick();
        return;
      }
      setIsFilterSidePanelOpen(!isFilterSidePanelOpen);
    };
    $[4] = isFilterSidePanelOpen;
    $[5] = onClick;
    $[6] = setIsFilterSidePanelOpen;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t4 || $[9] !== t5) {
    t6 = <Button icon={t4} onClick={t5} {...buttonProps} />;
    $[8] = t4;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t3 || $[12] !== t6) {
    t7 = <Media greaterThanOrEqual="xl"><Tooltip content={t3}>{t6}</Tooltip></Media>;
    $[11] = t3;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t2 || $[15] !== t7) {
    t8 = <>{t2}{t7}</>;
    $[14] = t2;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  return t8;
}
function _temp2(open) {
  return !open;
}
function _temp(v) {
  return [v.isFilterSidePanelOpen, v.setIsFilterSidePanelOpen, v.setIsFilterSheetOpen];
}